export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.22-1432.34",
  commitId: "f41ba3580c18bbc3b89362b8e39790959912ecb2",
  commitTime: "2026-10-22T14:32:34.000Z",
});
